import { notification } from 'antd';
import { FormattedMessage } from 'react-intl';
import translationsUI from '~/view/ui/translationUI';
import React from 'react';

export const openNotification = ({
  mess,
  time,
  type,
  id,
  key,
  btnComponent = false,
}) => {
  let message = '';
  let description = '';

  if (key) {
    // If key is provided, use it to get the translation from translationsUI
    const translationKey = translationsUI[key];
    if (translationKey) {
      description = <FormattedMessage {...translationKey} />;
    }
  } else {
    // Maintain backward compatibility
    message = id || '';
    description = mess;
  }

  const args = {
    message,
    description,
    duration: time,
    btn: btnComponent,
  };
  type ? notification[type](args) : notification.open(args);
};
